import React from 'react';
import {
    List, ListItemButton, ListItemText,
} from '@mui/material';
import TimelineIcon from '@mui/icons-material/Timeline';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import BarChartIcon from '@mui/icons-material/BarChart';
import {Link, useLocation} from 'react-router-dom';
import {useTranslation} from '../../common/components/LocalizationProvider';
import {useAdministrator} from '../../common/util/permissions';
import {useTheme} from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

const MenuItem = ({
                      title, link, icon, selected,
                  }) => (
    <ListItemButton key={link} component={Link} to={link} selected={selected}>
        <ListItemText primary={title}/>
    </ListItemButton>
);

const ReportsMenu = () => {
    const t = useTranslation();
    const location = useLocation();

    const admin = useAdministrator();

    const theme = useTheme();
    const phone = useMediaQuery(theme.breakpoints.down('md'));

    return (
        <>
            <List sx={phone ?
                null
                :
                {
                    // selected and (selected + hover) states
                    '&& .Mui-selected, && .Mui-selected:hover': {
                        bgcolor: '#414141'
                    },
                    // hover states
                    '& .MuiListItemButton-root:hover': {
                        bgcolor: '#666666'
                    },
                }}
                  style={{display: 'flex', flexDirection: phone ? 'column' : 'row', padding: 0}}>
                <MenuItem
                    title={t('reportRoute')}
                    link="/reports/route"
                    icon={<TimelineIcon/>}
                    selected={location.pathname === '/reports/route'}
                />
                <MenuItem
                    title={t('reportEvents')}
                    link="/reports/event"
                    icon={<NotificationsActiveIcon/>}
                    selected={location.pathname === '/reports/event'}
                />
                <MenuItem
                    title={t('reportChart')}
                    link="/reports/chart"
                    icon={<TrendingUpIcon/>}
                    selected={location.pathname === '/reports/chart'}
                />
            </List>
            {admin && (
                <>
                    <List sx={phone ?
                        null
                        :
                        {
                            // selected and (selected + hover) states
                            '&& .Mui-selected, && .Mui-selected:hover': {
                                bgcolor: '#414141'
                            },
                            // hover states
                            '& .MuiListItemButton-root:hover': {
                                bgcolor: '#666666'
                            },
                        }}
                          style={{display: 'flex', flexDirection: phone ? 'column' : 'row', padding: 0}}>
                        <MenuItem
                            title={t('statisticsTitle')}
                            link="/reports/statistics"
                            icon={<BarChartIcon/>}
                            selected={location.pathname === '/reports/statistics'}
                        />
                    </List>
                </>
            )}
        </>
    );
};

export default ReportsMenu;
